import { render, staticRenderFns } from "./relevant.vue?vue&type=template&id=1c4f4778&scoped=true"
import script from "./relevant.vue?vue&type=script&lang=js"
export * from "./relevant.vue?vue&type=script&lang=js"
import style0 from "./relevant.vue?vue&type=style&index=0&id=1c4f4778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4f4778",
  null
  
)

export default component.exports